/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Styled
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../../theme';
import { WidgetBlockStyled } from '../../../styled/WidgetContainerStyled';

export const WidgetMultiBalancesStyled = styled(WidgetBlockStyled)`
    padding: 24px;
`;

export const WidgetMultiBalancesListStyled = styled.div`
    padding: 24px 0;
`;

export const WidgetMultiBalancesItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    margin-top: 12px;

    &:first-child {
        margin-top: 0;
    }

    .widget-multi-balances__name {
        max-width: 200px;
    }
`;

export const WidgetMultiBalancesTitleStyled = styled.div`
    ${fonts.textHeader3}
    background: ${colors.backgroundColorSuccess};
    color: ${colors.textColorWhite};

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 24px;
    margin: 0;

    cursor: pointer;

    span:first-child {
        border-bottom: 1px solid transparent;
    }

    &:hover {
        span:first-child {
            border-bottom-color: ${colors.textColorWhite};
        }
    }
`;
